<mat-card (click)="detailMail()">
  <mat-card-header>
    <div class="avator">{{ data.cells['LastModifiedBy'].value[0] }}</div>
    <mat-card-title>{{ data.cells['Title'].value }}</mat-card-title>
    <mat-card-subtitle> {{ data.cells['LastModifiedBy'].displayText }} - {{ data.cells['LastModifiedBy'].displayText }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-actions>
    <div class="time">12.57 PM</div>
    <i class="fa-regular fa-star"></i>
    <i class="fa-solid fa-star active"></i>

    <label class="tag important">Important</label>
    <label class="tag meeting">Meeting</label>
    <div class="dot green"></div>
    <div class="dot purpel"></div>
    <div class="dot red"></div>
  </mat-card-actions>
</mat-card>
